























import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'FeesUnavailableOnAccount' })
export default class extends SaascadaVue {

}
